module.exports = __webpack_public_path__ + "img/4_newModelWorker_hkf.1dbe9645.png";